import { FaStethoscope, FaGraduationCap, FaLandmark, FaCartShopping, FaBullhorn, FaTruckFast } from 'react-icons/fa6';

const industries = {
    sub: "Industries We Serve",
    heading: "Empowering Your Business with AI",
    content: "Our AI SaaS platform delivers intelligent solutions tailored for various industries—enabling smarter decisions, optimized workflows, and scalable automation in the digital age.",
    points: [
        {
            id: 1,
            icon: <FaStethoscope />, // Healthcare icon
            title: 'Healthcare',
            content: 'Enhancing diagnostics & patient care through AI-powered automation.',
        },
        {
            id: 2,
            icon: <FaGraduationCap />, // Education icon
            title: 'Education',
            content: 'Deliver personalized learning & enhance virtual tutoring with AI capabilities.',
        },
        {
            id: 3,
            icon: <FaLandmark />, // Banking icon
            title: 'Banking',
            content: 'Automate compliance, and forecast financial trends using AI algorithms.',
        },
        {
            id: 4,
            icon: <FaCartShopping />, // E-commerce icon
            title: 'E-commerce',
            content: 'Personalize shopping and streamline inventory with predictive analytics.',
        },
        {
            id: 5,
            icon: <FaBullhorn />, // Marketing icon
            title: 'Marketing',
            content: 'Automate campaign & analyze customer behavior using smart AI tools.',
        },
        {
            id: 6,
            icon: <FaTruckFast />, // Logistics icon
            title: 'Logistics',
            content: 'Optimize routing, reduce delays, & forecast demand using automation.',
        },
    ]
}

export default industries;